export const sourceOptions = ['people', 'site', 'others', 'street'];

export const modalType = {
  TOS: 'TOS',
  MARKETING: 'MARKETING',
  OFFERS: 'OFFERS',
};
